// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wW5h","title":"styles_title__eogQF"};